import { render, staticRenderFns } from "./ProductListCustomization.vue?vue&type=template&id=09dd4703&"
import script from "./ProductListCustomization.vue?vue&type=script&lang=js&"
export * from "./ProductListCustomization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports